import { render, staticRenderFns } from "./BackgroundSettings.vue?vue&type=template&id=20950b2d&scoped=true"
import script from "./BackgroundSettings.vue?vue&type=script&lang=js"
export * from "./BackgroundSettings.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSettings.vue?vue&type=style&index=0&id=20950b2d&prod&lang=scss&scoped=true"
import style1 from "./BackgroundSettings.vue?vue&type=style&index=1&id=20950b2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20950b2d",
  null
  
)

export default component.exports